import axios from './axios';

export const fetchAvailableAdvisors = (date, time, budgetId, autocareEmailHash) =>
    axios.get(`/advisors/schedule/available?date=${date}${time ? `&time=${time}` : ''}${budgetId ? 
        `&budgetId=${budgetId}` : ''}&autocare=${autocareEmailHash}`);

export const fetchAvailableHours = (date, autocare='') =>
    axios.get(`/advisors/schedule/hours?date=${date}&general=1&autocare=${autocare}`);

export const fetchAvailableHoursAdvisorRequester = (data) =>
    axios.get(`/advisors/public/${data.advisorEmailHash}/schedule/hours?date=${data.date}`);

export const fetchEmptyDatesRequester = (data, autocare) =>
    axios.get(`/advisors/empty/schedule/?date=${data}&autocare=${autocare}`);



// WEBPACK FOOTER //
// ./src/requesters/advisors.js